import React from 'react';
import PageBanner from 'components/banners/PageBanner';
// import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import computer from 'assets/images/mailing.jpeg';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';

function MailingWizard() {
  return (
    <div>
      <Helmet>
        <title>Mailing Wizard - CAP60</title>
        <meta
          name="description"
          content="Cap60s' mailing wizard send mass emails and you can also selct targated audience. Contact us Now!."
        />
        <meta name="keyword" content="mailing wizard, cap60 mailing wizard" />
      </Helmet>
      <PageBanner
        title="Mailing Wizard"
        subtitle="Send emails and USPS with ease"
      />
      <ClienDesk />
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>Mailing checklist:</h2>
            </div>
            <ol>
              <li>Regularly schedule emails</li>
              <li>Print letters for USPS delivery</li>
              <li>Send mass emails or to a select audience</li>
              <li>Print mailing labels</li>
            </ol>
            <p>
              No matter your mailing needs, the CAP60 Mailing Wizard can handle
              them. Your agency has multiple communication channels and we want
              to help you manage those with ease.
            </p>

            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image height={300} src={computer} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MailingWizard;
